module.exports = __webpack_public_path__ + "static/media/MapIcon.510e628d.png";